// import { toastMessage } from "./toastMessage";

import { toastMessage } from "./toastMessage";

// /**
//  * Handles copying text to the clipboard and shows a toast message.
//  * @param {string} name - The text to copy to the clipboard.
//  */
// export const handleCopy = (name) => {
//     if (!name) {
//         toastMessage("Clipboard is empty", 'error', 'clipboard');
//         return;
//     }

//     navigator.clipboard?.writeText(name)
//         .then(() => {
//             toastMessage(`"${name}" copied to clipboard!`, 'success', 'clipboard');
//         })
//         .catch((err) => {
//             toastMessage("Failed to copy to clipboard.", 'error', 'clipboard');
//             console.error("Clipboard error:", err);
//         });
// };

export const handleCopy = (name) => {
  if (!name) {
    toastMessage("Clipboard is empty", "error", "clipboard");
    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(name)
      .then(() => {
        toastMessage(`Copied to clipboard !`, "success", "clipboard");
      })
      .catch((err) => {
        toastMessage("Failed to copy to clipboard.", "error", "clipboard");
        console.error("Clipboard error:", err);
      });
  } else {
    // Fallback for older browsers
    const textArea = document.createElement("textarea");
    textArea.value = name;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    toastMessage(`"${name}" copied to clipboard!`, "success", "clipboard");
  }
};
